module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./BusinessGiftbagView.js"));
	}, "BusinessGiftbagView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessGiftbagView!./src/pages/Store/BusinessManage/BusinessGiftbag/BusinessGiftbagView.js
// module id = 1209
// module chunks = 431